import { useState } from "react";
import CustomInput from "../../shared/CustomInput";
import Button from "../../shared/Button";
import { useMutation } from "react-query";
import { useError } from "../../context/ErrorProvider";
import { sendIdentifier } from "../../sdk/auth/auth";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const { showError } = useError();
  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation({
    mutationKey: ["forgot identifier"],
    mutationFn: () => sendIdentifier(email.trim()),
    onSuccess: (data) => {
      if (data?.status === 201) {
        navigate("/reset-password-otp");
        localStorage.setItem("resetIdentifier", email?.trim());
      }
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await mutate();
  };
  return (
    <div className="h-full w-[80%] flex flex-col pb-[100px] justify-end">
      <p className="text-[#222222] font-semibold text-[24px]">
        Forgot Password
      </p>
      <p className="text-[#5C5C5C] font-medium text-[13px]">
        Enter your email and we’ll send a reset code to your registered mobile
        number.
      </p>
      <form className="w-full" onSubmit={handleSubmit} autoComplete="off">
        <div className="flex flex-col gap-[5px] mt-[20px] my-[50px]">
          <label
            className="font-medium text-[13px] text-[#000000]"
            htmlFor="email"
          >
            Email
          </label>
          <CustomInput
            placeholder="Enter email address"
            type="text"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setErrors((prev) => ({ ...prev, email: "" }));
            }}
          />
          {errors.email && (
            <p className="text-red-500 text-[12px]">{errors.email}</p>
          )}
        </div>
        <Button label="Send" isLoading={isLoading} disabled={isLoading} />
      </form>
    </div>
  );
};

export default ForgotPassword;
